import TeMenu from './index.vue';


TeMenu.install = function(Vue) {
  Vue.component(TeMenu.name, TeMenu);
};

export default TeMenu;